export default "__VITE_ASSET__BvK2wX_k__"